import React from 'react';
import { NumericFormat } from 'react-number-format';

const NumberInput = props => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      allowNegative={false}
      {...other}
    />
  );
};

export default NumberInput;
